export default __webpack_public_path__ + "static/media/I14.9f9dee37.jpg";